import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let ticketIndex = () => import(/* webpackChunkName: "tickets" */ '@/views/support/tickets/Index');
let ticketShow = () => import(/* webpackChunkName: "tickets" */ '@/views/support/tickets/Show');
let ticketCreate = () => import(/* webpackChunkName: "tickets" */ '@/views/support/tickets/Create');

export default [
    ...prefix("/support",[
        {
            path: "tickets",
            name: "ticket.index",
            component: ticketIndex,
            meta: {
                middleware: web,
                title: "لیست تیکت ها"
            }
        },
        {
            path: "tickets/create",
            name: "ticket.create",
            component: ticketCreate,
            meta: {
                middleware: web,
                title: "ایجاد تیکت | فروشگاه ساز میهن شاپ"
            }
        },
        {
            path: "tickets/:ticket",
            name: "ticket.show",
            component: ticketShow,
            meta: {
                middleware: web,
                title: ""
            }
        },
    ])
]